import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FranchiseInfo {
  id: string;
  name: string;
  ownerName: string;
  type: 'rental' | 'ride' | 'both';
  status: 'active' | 'inactive' | 'pending';
  permissions: string[];
}

interface FranchiseState {
  currentFranchise: FranchiseInfo | null;
  isAuthenticated: boolean;
  permissions: string[];
}

const initialState: FranchiseState = {
  currentFranchise: null,
  isAuthenticated: false,
  permissions: []
};

// 模拟加盟商权限
const FRANCHISE_PERMISSIONS = [
  'franchise:dashboard:view',
  'franchise:vehicles:view',
  'franchise:vehicles:create',
  'franchise:vehicles:edit',
  'franchise:vehicles:delete',
  'franchise:drivers:view',
  'franchise:drivers:create',
  'franchise:drivers:edit',
  'franchise:drivers:delete',
  'franchise:orders:view',
  'franchise:orders:edit',
  'franchise:users:view'
];

const franchiseSlice = createSlice({
  name: 'franchise',
  initialState,
  reducers: {
    loginFranchise: (state, action: PayloadAction<FranchiseInfo>) => {
      state.currentFranchise = action.payload;
      state.isAuthenticated = true;
      // 根据加盟商类型设置权限
      state.permissions = FRANCHISE_PERMISSIONS;
    },
    logoutFranchise: (state) => {
      state.currentFranchise = null;
      state.isAuthenticated = false;
      state.permissions = [];
    },
    updateFranchiseInfo: (state, action: PayloadAction<Partial<FranchiseInfo>>) => {
      if (state.currentFranchise) {
        state.currentFranchise = { ...state.currentFranchise, ...action.payload };
      }
    }
  }
});

export const { loginFranchise, logoutFranchise, updateFranchiseInfo } = franchiseSlice.actions;
export default franchiseSlice.reducer;